module.exports = __webpack_public_path__ + "img/foolproof.22c04bc0.png";